import * as React from 'react';
import { RedirectLoader } from 'Views/Components/_HumanWritten/RedirectLoader/RedirectLoader';

function ChangeEmailPage() {
	return <RedirectLoader to="/" title="Your email has been verified!" subtitle="Navigating to home page..." />;
}

export default ChangeEmailPage;
